// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__rTjhl","nav":"Menu_nav__LDwIr","main":"Menu_main__us6LE","title":"Menu_title__O4F-s","showTitle":"Menu_showTitle__52XgX"};